"use client";

import { StatisticsSectionProps } from "@/Templates/SectionsProps";
import { FC } from "react";
import GeneratedStatisticsSection from "../Components/GeneratedStatisticsSection";

const Statistics: FC<StatisticsSectionProps> = (props) => {
  return <GeneratedStatisticsSection {...props} />;
};

export default Statistics;
